import { useState } from 'react';

import { CloseButton, Row, Text } from '@opendoor/bricks-next';

import useQueryParams from '../../helpers/queryParams';

const MaintenanceBanner = () => {
  const { maintenance_start_time_local } = useQueryParams();
  const [showBanner, setShowBanner] = useState(maintenance_start_time_local !== undefined);
  const closeBanner = () => setShowBanner(false);

  if (!showBanner) return null;

  return (
    <Row
      py="$4"
      px="$6"
      backgroundColor="$backgroundStateErrorSecondary"
      mx="auto"
      justifyContent="space-between"
    >
      <Text
        tag="p"
        typography="$bodyMedium"
        fontWeight="$medium"
        flexGrow={1}
        textAlign="center"
        $largerThanMD={{ typography: '$bodyLarge' }}
      >
        Opendoor will be down for scheduled maintenance on {maintenance_start_time_local}
      </Text>
      <CloseButton
        size="small"
        onPress={closeBanner}
        id="maintenance-banner-close-button"
        iconLabel="Close banner"
        analyticsName="cosmos-maintenance-banner-close"
        alignSelf="center"
      />
    </Row>
  );
};

export default MaintenanceBanner;
